import { defineStore } from 'pinia';
import { type MessageType } from '../types';
import { AmplitudeCustomEvents, track } from '@/lib/amplitude';
import { SuiMessageTypeType } from '@developers/scoro-ui';
import { getUniqueId } from '@/utils/misc';

export const useMessagesStore = defineStore('messages', {
	state: () => ({
		messages: [] as MessageType[],
	}),
	actions: {
		addMessage(message: MessageType) {
			const findDuplicate = this.messages.findIndex(
				(msg) =>
					msg.title === message.title &&
					msg.message === message.message
			);

			if (!('id' in message) || typeof message.id === 'undefined') {
				message.id = getUniqueId();
			}

			if (findDuplicate >= 0) {
				const message = this.messages[findDuplicate];
				this.messages[findDuplicate].repeat = message.repeat
					? message.repeat + 1
					: 1;
			} else {
				if (message.type == SuiMessageTypeType.Error) {
					track(AmplitudeCustomEvents.ErrorEncountered, {
						error_message: message.message,
					});
				}
				this.messages.push({
					...message,
					repeat: 0,
				});
			}
		},

		deleteMessage(messageId: MessageType['id']) {
			this.messages = this.messages.filter(
				(message) => message.id !== messageId
			);
		},
	},
});
